import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from "@angular/platform-browser";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { EventiService } from 'src/app/services/eventi.service';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { DialogService } from 'src/app/services/dialog.service';
import { StatiEvento } from 'src/app/model/StatiEvento.enum';
import { SegnalazioniService } from 'src/app/services/segnalazioni.service';
import { RightSidebarDirective } from 'src/app/shared/directives/right-sidebar.directive';

@Component({
  selector: 'app-dettaglio-evento',
  templateUrl: './dettaglio-evento.component.html',
  styleUrls: ['./dettaglio-evento.component.css'],
  providers: [MatIconRegistry, EventiService]
})
export class DettaglioEventoComponent implements OnInit, OnDestroy {

  @Output() public closeDetail = new EventEmitter<boolean>();
  public form: FormGroup;
  public date = new Date((new Date().getTime() - 3888000000));
  /*Flag per verificare se siamo in dettaglio/readonly*/
  public isDettaglio: boolean;
  /*Flag per verificare se siamo in modifica*/
  public isModifica: boolean;
  public navigationSubscription;
  ocdpc: string = '';
  acl: string = sessionStorage.getItem("acl");
  showInvADipPCButton: boolean = false;
  showEmerNonRicButton: boolean = false;
  haSegnalazioni: boolean = false;
  oldDataInizioEvento: string;
  oldDataFineEvento: string;
  canInsert: boolean = false;
  idEventoParams?: number;


  constructor(
    private dialogSvc: DialogService,
    private matIconRegistry: MatIconRegistry,
    private eventiSvc: EventiService,
    private domSanitizer: DomSanitizer,
    private segnalazioniSvc: SegnalazioniService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private alertsCenterService: AlertsCenterService) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {

      if (e instanceof NavigationEnd) {
        this.modeSelector();
      }
    });
  }


  ngOnInit(): void {
    this.modeSelector();
    this.showInviaADipartimentoPCButton();
  }

  private modeSelector() {
    this.isDettaglio = this.router.url === '/nuovo-evento' ? false : true;
    if (this.isDettaglio) {
      this.isModifica = this.router.url.startsWith('/modifica-evento') ? true : false;
      this.buildFormDetail();
    } else this.buildForm();
  }

  public isDgpe() {
    return sessionStorage.getItem("acl") == "dgpe";
  }

  buildForm() {
    this.form = new FormGroup({
      codiceEvento: new FormControl(null, null),
      dataEvento: new FormControl({ value: null, disabled: this.isDettaglio && !this.isModifica }, [Validators.required]),
      denominazione: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      descrizione: new FormControl(null, [Validators.maxLength(2000)]),
      dataInizioEvento: new FormControl({ value: null, disabled: this.isDettaglio && !this.isModifica }),
      dataFineEvento: new FormControl({ value: null, disabled: this.isDettaglio && !this.isModifica }),
      dpgr: new FormControl(null, [Validators.required, Validators.maxLength(10)]),
      stato: new FormControl({ value: null, disabled: true }, [Validators.required, Validators.maxLength(10)]),
      utenteUltimaMod: new FormControl({ value: null, disabled: true }, null),
      dataUltimaMod: new FormControl({ value: null, disabled: true }, null)
    });
  }

  private buildFormDetail() {
    this.buildForm();
    this.eventiSvc.getEvento(this.route.snapshot.params.id).toPromise().then(res => {
      let dtlastMod = res.dtUltimaModifica ? res.dtUltimaModifica : res.dataEvento
      this.ocdpc = res.ocdpc != null ? res.ocdpc : '',
        this.form = new FormGroup({
          codiceEvento: new FormControl(res.idEvento, [Validators.required]),
          dataEvento: new FormControl({ value: res.dataEvento, disabled: this.isDettaglio && !this.isModifica }, [Validators.required]),
          denominazione: new FormControl({ value: res.denominazione, disabled: this.isDettaglio && !this.isModifica }, [Validators.required, Validators.maxLength(100)]),
          descrizione: new FormControl({ value: res.descrizione, disabled: this.isDettaglio && !this.isModifica }, [Validators.maxLength(2000)]),
          dataInizioEvento: new FormControl({ value: res.dataInizioEvento, disabled: this.isDettaglio && !this.isModifica }),
          dataFineEvento: new FormControl({ value: res.dataFineEvento, disabled: this.isDettaglio && !this.isModifica }),
          utenteUltimaMod: new FormControl({ value: res.utenteUltimaModifica, disabled: true }, null),
          dataUltimaMod: new FormControl({ value: dtlastMod, disabled: true }, null),
          dpgr: new FormControl({ value: res.dpgr, disabled: this.isDettaglio && !this.isModifica }, [Validators.required, Validators.maxLength(10)]),
          stato: new FormControl({ value: res.stato, disabled: true }, [Validators.required, Validators.maxLength(10)])
        });
      this.oldDataInizioEvento = res.dataInizioEvento,
        this.oldDataFineEvento = res.dataFineEvento,
        this.showEmergenzaNonRiconosciutaButton(res.stato);
    },
      err => {
        this.alertsCenterService.showAlert({
          message: err.error.esitoServizio.descrizioneEsito,
          type: 'danger',
          autoClosable: false
        });
        this.router.navigate(['/lista-eventi']);
      });
  }

  onNavigate(path: string, denominazione?: string) {
    switch (path) {
      case 'template-list': {
        this.router.navigate([this.router.url + "/" + path], { state: { denominazione: denominazione } });
        break;
      }
      case 'lista-eventi': {
        this.router.navigate([path]);
        break;
      }
      case 'enti-delegati': {
        this.router.navigateByUrl("modifica-evento/"+this.idEventoParams+"/enti-delegati");
        break;
      }
      default: {
        break;
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.route.snapshot.params.id != undefined) {
      this.idEventoParams = this.route.snapshot.params.id;
      this.valorizzaHaSegnalazioni();
    }
  }

  onSaveEvent() {
    let newEvent: ModelEventiCalamitosi.EventoDto = {
      idEvento: this.form.controls.codiceEvento.value ? this.form.controls.codiceEvento.value : null,
      dataEvento: this.datePipe.transform(this.form.controls.dataEvento.value, "yyyy-MM-dd"),
      dataInizioEvento: this.form.controls.dataInizioEvento.value ? this.datePipe.transform(this.form.controls.dataInizioEvento.value, "yyyy-MM-dd") : null,
      dataFineEvento: this.form.controls.dataFineEvento.value ? this.datePipe.transform(this.form.controls.dataFineEvento.value, "yyyy-MM-dd") : null,
      denominazione: this.form.controls.denominazione.value,
      descrizione: this.form.controls.descrizione.value,
      dpgr: this.form.controls.dpgr.value,
      dtUltimaModifica: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
      utenteUltimaModifica: this.form.controls.utenteUltimaMod.value ? this.form.controls.utenteUltimaMod.value : '',
      stato: this.form.controls.stato.value ? this.form.controls.stato.value : StatiEvento.IN_BOZZA,
      ocdpc: null
    }
    if (!this.isModifica) {
      if (!this.form.controls.dataEvento.errors && !this.form.controls.denominazione.errors && !this.form.controls.dpgr.errors && !this.form.controls.descrizione.errors
        && !this.form.controls.dataInizioEvento.errors && !this.form.controls.dataFineEvento.errors && this.checkData(newEvent)) {
          if (this.haSegnalazioni && (this.oldDataInizioEvento != newEvent.dataInizioEvento || this.oldDataFineEvento != newEvent.dataFineEvento)) {
            let title = "ATTENZIONE"
            let message = "L'evento di cui si stanno modificando le date risulta avere delle " +
              "segnalazioni già censite, potrebbero esserci delle incongruenze, procedere comunque?"
            this.dialogSvc.openDialog(title, message).subscribe(res => {
              let confirmed = `${res}`;
              if (confirmed == "true") {
                this.upsertEvento(newEvent);
              }
            });
          } else {
            this.upsertEvento(newEvent);
          }
      } else this.markAsTouched()
    }
    else {
      if (!this.form.invalid) {
        if (this.checkData(newEvent)) {
          if (this.haSegnalazioni && (this.oldDataInizioEvento != newEvent.dataInizioEvento || this.oldDataFineEvento != newEvent.dataFineEvento)) {
            let title = "ATTENZIONE"
            let message = "L'evento di cui si stanno modificando le date risulta avere delle " +
              "segnalazioni già censite, potrebbero esserci delle incongruenze, procedere comunque?"
            this.dialogSvc.openDialog(title, message).subscribe(res => {
              let confirmed = `${res}`;
              if (confirmed == "true") {
                this.upsertEvento(newEvent);
              }
            });
          } else {
            this.upsertEvento(newEvent);
          }
        }
      }
    }
  }

  private upsertEvento(newEvent: ModelEventiCalamitosi.EventoDto) {
    this.eventiSvc.upsertEvento(newEvent).toPromise().then(res => {
      this.alertsCenterService.showAlert({
        message: `Salvataggio effettuato con successo`,
        type: 'success',
        autoClosable: false
      });
      this.router.navigate(['modifica-evento/' + res.body.idEvento]);
    },
      err => {
        this.alertsCenterService.showAlert({
          message: err.error.esitoServizio.descrizioneEsito,
          type: 'danger',
          autoClosable: false
        });
      });
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  markAsTouched() {
    this.form.controls.dpgr.markAsTouched();
    this.form.controls.dataEvento.markAsTouched();
    this.form.controls.denominazione.markAsTouched();
  }

  openInvioDipartimentoPCDialog() {
    let title = 'INVIA A DIPARTIMENTO P.C.';
    let message = 'Inviare le segnalazioni per questo evento a P.C. ?';
    this.dialogSvc.openDialog(title, message).subscribe(res => {
      let confirmed = `${res}`;
      if (confirmed == "true") {
        this.eventiSvc.inviaADipartimentoPC(this.form.controls.codiceEvento.value).subscribe(
          res => {
            this.alertsCenterService.showAlert({
              message: 'Invio segnalazioni al Dipartimento P.C. avvenuta con successo',
              type: 'success',
              autoClosable: false
            })
            this.router.navigate(['dettaglio-evento/' + res.body.idEvento]);
            this.showInviaADipartimentoPCButton();
          },
          err => {
            this.alertsCenterService.showAlert({
              message: err.error.esitoServizio.descrizioneEsito,
              type: 'danger',
              autoClosable: false
            });
          }
        );
      }
    });
  }

  openEmergNonRicDialog() {
    let title = 'EMERGENZA NON RICONOSCIUTA';
    let message = 'Non riconoscere lo stato di emergenza di questo evento?';
    this.dialogSvc.openDialog(title, message).subscribe(res => {
      let confirmed = `${res}`;
      if (confirmed == "true") {
        this.eventiSvc.nonRiconoscereEmergenzaEvento(this.form.controls.codiceEvento.value).subscribe(
          res => {
            this.alertsCenterService.showAlert({
              message: 'Stato di emergenza non riconosciuta di questo evento avvenuta con successo',
              type: 'success',
              autoClosable: false
            })
            this.router.navigate(['modifica-evento/' + res.body.idEvento]);
          },
          err => {
            this.alertsCenterService.showAlert({
              message: err.error.esitoServizio.descrizioneEsito,
              type: 'danger',
              autoClosable: false
            });
          }
        );
      }
    });
  }

  private checkData(evento: ModelEventiCalamitosi.EventoDto): boolean {

    if (evento.dataInizioEvento && evento.dataFineEvento) {
      if (evento.dataInizioEvento > evento.dataFineEvento) {
        let message = "Data di inizio maggiore della data di fine"
        this.alertsCenterService.showAlert({
          message: message,
          type: 'danger',
          autoClosable: false
        });
        return false;
      }
    }

    return true;
  }

  private valorizzaHaSegnalazioni() {
    let segnalazioneFilter: ModelEventiCalamitosi.SegnalazioniSearchableDto = {
      idEvento: this.idEventoParams,
      codiceSegnalazione: null,
      descrizioneSegnalazione: null,
      idEnte: null,
      stato: null,
      tipoRichiesta: null,
      flRettificata: null,
      identificativoInvio: null,
      statoIntervento: null,
      statoPerOperazione: null
    };
    this.segnalazioniSvc.getNumeroSegnalazioniPerEvento(segnalazioneFilter).subscribe(
      res => {
        if (res > 0) {
          this.haSegnalazioni = true;
        } else this.haSegnalazioni = false;
      }
    );
  }

  showInviaADipartimentoPCButton() {
    this.showInvADipPCButton = false;
    if (this.route.snapshot.params.id != undefined) {
      this.eventiSvc.numSegnalazioniNonIdoneeInvioEvento(this.route.snapshot.params.id).subscribe(res => {
        if (res == 0) {
          this.showInvADipPCButton = true;
        } else {
          this.showInvADipPCButton = false;
        }
      }, err => {
        this.showInvADipPCButton = false;
      })
    }
  }

  showEmergenzaNonRiconosciutaButton(statoEvento: string) {

    if (statoEvento == StatiEvento.ATTESA_EMERGENZA) {
      this.showEmerNonRicButton = true;
    } else {
      this.showEmerNonRicButton = false;
    }
  }
}
